import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const NET_INCOME_NAMES = {
  FINANCIAL_INCOME: 'financialIncome',
  FINANCIAL_EXPENSES: 'financialExpenses',
  NON_OPERATING_INCOME: 'nonOperatingIncome',
  NON_OPERATING_EXPENSES: 'nonOperatingExpenses',
  INCOME_TAX: 'incomeTax',
  NET_INCOME: 'netIncome',
} as const;

export const useGetNetIncomeTableHeadings = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const netIncomeFields = {
      [NET_INCOME_NAMES.FINANCIAL_INCOME]: {
        title: t('financialPlan.profitAndLossProjection.netIncome.financialIncome'),
        name: NET_INCOME_NAMES.FINANCIAL_INCOME,
      },
      [NET_INCOME_NAMES.NON_OPERATING_INCOME]: {
        title: t('financialPlan.profitAndLossProjection.netIncome.nonOperatingIncome'),
        name: NET_INCOME_NAMES.NON_OPERATING_INCOME,
      },
    };

    const netIncomeLinkedFields = {
      financialExpenses: {
        title: t('financialPlan.plannedExpenses.monthlyExpenses.financialExpenses'),
      },
      nonOperatingExpenses: {
        title: t('financialPlan.plannedExpenses.monthlyExpenses.nonOperatingExpenses'),
      },
    };

    const incomeTaxRowTitle = t('financialPlan.profitAndLossProjection.netIncome.incomeTax');
    const totalRowTitle = t('financialPlan.profitAndLossProjection.netIncome.netIncomeForPeriod');
    return { netIncomeFields, netIncomeLinkedFields, incomeTaxRowTitle, totalRowTitle };
  }, [t, i18n]);
};

export interface INetIncomeFormValuesType {
  [NET_INCOME_NAMES.FINANCIAL_INCOME]: IPeriodsTableRow[];
  [NET_INCOME_NAMES.NON_OPERATING_INCOME]: IPeriodsTableRow[];
  [NET_INCOME_NAMES.INCOME_TAX]: IPeriodsTableRow;
  [NET_INCOME_NAMES.NET_INCOME]: IPeriodsTableRow;
  [NET_INCOME_NAMES.FINANCIAL_EXPENSES]: IPeriodsTableRow;
  [NET_INCOME_NAMES.NON_OPERATING_EXPENSES]: IPeriodsTableRow;
}

export const netIncomeInitialValues: INetIncomeFormValuesType = {
  [NET_INCOME_NAMES.FINANCIAL_INCOME]: [initialPeriodsTableRow],
  [NET_INCOME_NAMES.NON_OPERATING_INCOME]: [initialPeriodsTableRow],
  [NET_INCOME_NAMES.INCOME_TAX]: initialPeriodsTableRow,
  [NET_INCOME_NAMES.NET_INCOME]: initialPeriodsTableRow,
  [NET_INCOME_NAMES.FINANCIAL_EXPENSES]: initialPeriodsTableRow,
  [NET_INCOME_NAMES.NON_OPERATING_EXPENSES]: initialPeriodsTableRow,
};
